/**
 * Index Presenter
 */
class IndexPresenter extends AbstractProductsPresenter {

	constructor() {

		super();
		
		this.view = new IndexView(this);

		/*
		 * Listeners
		 */

		/*
		 * Initialisation
		 */

	}

	/*
	 * Actions
	 */

}